import { AddToModelParamList, METHOD } from "../utils";

/**
 * Decorator that will determine a method on the database model
 * 
 * @return Function
 *   Will return a function that will be used by the Reflection API to build out everything on the object
 */
export function Method() {
    return (target: any, propertyKey: string) => {
        AddToModelParamList(target, propertyKey);
        Reflect.defineMetadata(METHOD, target[propertyKey], target, propertyKey);
    }
}